import React from 'react';
import { motion } from 'framer-motion';
import './HeartSection.css';
import '../Banner.css';

import bgImage from '../../Assets/health/bgimage.png';
import defaultHeartImage from '../../Assets/health/heart.png';
import defaultPeopleImage from '../../Assets/health/people.png';
import defaultPulseLine from '../../Assets/health/Layer_1.png';
import { useLocation } from 'react-router-dom';

const HeartBanner = ({
  videoSrc,
  heading = "Default Heading",
  subtext = "Default subtext for the banner goes here.",
  buttonText = "Learn More",
  onButtonClick,
  heartImageSrc = defaultHeartImage,
  peopleImageSrc = defaultPeopleImage,
  pulseLineSrc = defaultPulseLine,
}) => {
  const location = useLocation();
  const isCareer = location.pathname === "/Career";
  const isContact = location.pathname === "/Contact";
  const isLeadership = location.pathname === "/leadership";

  const sectionClass = isCareer
    ? "heartbanner-section1"
    : isContact && isLeadership
    ? "heartbanner-section2"
    : "heartbanner-section";

  const contentClass = isCareer
    ? "heartbanner-content1"
    : isContact && isLeadership
    ? "heartbanner-content2"
    : "heartbanner-content";

  const videoBgClass = isCareer || isContact && isLeadership
    ? "heartvideo-bg1"
    : "heartvideo-bg";

  return (
    <section
      className={`heart-section ${sectionClass}`}
      style={isCareer || isLeadership ? {} : { backgroundImage: `url(${bgImage})` }}
    >
      <div className={videoBgClass}>
        {videoSrc && (
          <video
            src={videoSrc}
            autoPlay
            loop
            muted
            playsInline
            className="heartbg-video"
          />
        )}
      </div>

      <motion.div
        className={contentClass}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 dangerouslySetInnerHTML={{ __html: heading }} />
        <p>{subtext}</p>
        <button className="explore-btn1" onClick={onButtonClick}>
          {buttonText}
        </button>
      </motion.div>

      {pulseLineSrc && (
        <motion.img
          src={pulseLineSrc}
          alt="Pulse Left"
          className="pulse-line left"
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 3 }}
        />
      )}

      {heartImageSrc && (
        <motion.img
          src={heartImageSrc}
          alt="Heart"
          className="heart-image"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.2, delay: 0.5 }}
        />
      )}

      {pulseLineSrc && (
        <motion.img
          src={pulseLineSrc}
          alt="Pulse Right"
          className="pulse-line right"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        />
      )}

      <motion.img
        src={peopleImageSrc}
        alt="Team"
        className="people-image"
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
      />
    </section>
  );
};

export default HeartBanner;
